import { render, staticRenderFns } from "./cuccImg.vue?vue&type=template&id=6f71da36&scoped=true&"
import script from "./cuccImg.vue?vue&type=script&lang=js&"
export * from "./cuccImg.vue?vue&type=script&lang=js&"
import style0 from "./cuccImg.vue?vue&type=style&index=0&id=6f71da36&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f71da36",
  null
  
)

export default component.exports